<template>
    <div v-if="is_not_correct_user||is_correct_user">
        <div class="box">
            <h3><i></i>得分率分布</h3>
            <div id="scoreChart"
                 style="width:15rem; height: 9.5rem;"></div>
        </div>
        <div class="con">
            <h3>未完成<span>{{is_not_correct_user.length}}</span>人</h3>
            <div class="uncorrect correctbox"
                 v-if="is_not_correct_user.length">
                <span v-for="(item,index) in is_not_correct_user"
                      :key="index">{{item}}</span>
            </div>
        </div>
        <div class="con"
             v-if="is_correct_user.length">
            <h3>已完成<span>{{is_correct_user.length}}</span>人</h3>
            <div class="corrected correctbox">
                <table>
                    <tbody>
                        <tr>
                            <th>姓名</th>
                            <th>成绩</th>
                            <th>提交时间</th>
                        </tr>
                        <tr v-for="(item,index) in is_correct_user"
                            :key="index"
                            @click="toDetail(item)">
                            <td>{{item.username}}</td>
                            <td>{{item.score}}分</td>
                            <td class="c-999">{{item.test_date}} <i class="icon_arrow_right"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: ['is_correct_user', 'is_not_correct_user', 'score_group', 'message_id', 'unitId', 'unit_score_rate', 'dept_type'],
    data () {
        return {
            // inApp: localStorage.getItem("search") && JSON.parse(localStorage.getItem("search")).platform,
            // inApp: true,
            array: [],
            sid: this.$route.query.sid,
            cid: this.$route.query.taskId,
            hd_type: this.$route.query.hd_type
        }
    },
    created () {

    },
    mounted () {
        setTimeout(() => {
            this.initChart();
            MathJax.Hub.Typeset(document.body)
        }, 500)
    },
    watch: {
        unitId () {
            this.$nextTick(() => {
                this.initChart();
            })
        }
    },
    computed: {

    },
    methods: {
        setIndex (score) {
            let num = score == 0 ? 0 : parseInt(score / 20);
            if (score == 100) {
                num = 4;
            }
            return num;
        },
        initChart () {
            let _this = this;
            //console.log(_this.score_group)
            _this.score_group.forEach(e => {
                _this.array.push(e.num);
            });
            let chartDom = document.getElementById('scoreChart');
            let myChart = echarts.init(chartDom);
            // let xNum = _this.setIndex(_this.stuData.score);
            let XArray = ['0%-20%', '20%-40%', '40%-60%', '60%-80%', '80%-100%'];
            // return false
            let option = {
                grid: {
                    top: '10%',
                    left: '1%',
                    right: '10%',
                    bottom: '4%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: XArray,
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '8'      //更改坐标轴文字大小
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}人'
                    }
                },
                series: [
                    {
                        data: _this.array,
                        type: 'line',

                        markLine: {
                            data: [
                                {
                                    symbol: 'none',
                                    xAxis: XArray[_this.setIndex(_this.unit_score_rate)],
                                    label: {
                                        position: 'end',
                                        formatter: function () { return '班级平均' },
                                    },
                                }
                            ]
                        },
                        areaStyle: {
                            opacity: 0.6,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#85aefd'
                                },
                                {
                                    offset: 1,
                                    color: '#d8e5fe'
                                }
                            ])
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        },

        toDetail (stu) {
            console.log(stu)
            localStorage.setItem('teaTaskUnitData', JSON.stringify(this.array))
            let qStr = this.$route.query.testType == "qz" ? "&is_qz=1" : this.$route.query.testType == "qm" ? "&is_qm=2" : '';
            let dept_type = this.$route.query.dept_type == 2 ? "&dept_type=2" : ''
            if (this.$route.query.taskType == '2022winter' || this.$route.query.taskType == '2023winter' || this.$route.query.taskType == '2024winter') {
                this.$router.push(`/personaLearning/stuDetail?sid=${this.sid}&cid=${this.cid}&userId=${stu.user_id}&name=${stu.username}&score=${stu.score}&taskType=${this.$route.query.taskType}`)
                return
            } else if (this.hd_type) {
                this.$router.push(`/personaLearning/stuDetail?sid=${this.sid}&cid=${this.cid}&userId=${stu.user_id}&name=${stu.username}&score=${stu.score}&hd_type=${this.hd_type}${dept_type}`);
            } else {
                this.$router.push(`/personaLearning/stuDetail?sid=${this.sid}&cid=${this.cid}&userId=${stu.user_id}&name=${stu.username}&score=${stu.score}${qStr}${dept_type}`);
            }

        },
        picView (index) {
            this.$router.push('/chinese/inspect/mytask/' + this.message_id + '/' + index.user_id + '/' + index.real_name + '?score=' + index.score)
        },
    },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 25px / $ppr auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("../img/icon04.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.con {
    width: 660px / $ppr;
    margin: 0 auto;
    h3 {
        color: #3c7cfb;
        font-size: 24px / $ppr;
        line-height: 74px / $ppr;
        height: 74px / $ppr;
        font-weight: bold;
        span {
            font-size: 28px / $ppr;
            margin: 0 10px / $ppr;
            position: relative;
            top: 2px / $ppr;
        }
    }
    .correctbox {
        width: 600px / $ppr;
        padding: 24px / $ppr 30px / $ppr;
        margin: 0 auto 35px / $ppr;
        border-radius: 16px / $ppr;
        background: #fff;
    }
    .uncorrect {
        span {
            width: 25%;
            display: inline-block;
            text-align: center;
            line-height: 80px / $ppr;
            height: 80px / $ppr;
            overflow: hidden;
        }
    }
    .corrected {
        width: 100%;
        padding: 0;
        table {
            text-align: center;
            width: 100%;
            th {
                font-weight: bold;
            }
            th,
            td {
                width: 33.33333%;
                text-align: center;
                padding-top: 30px / $ppr;
                padding-bottom: 30px / $ppr;
                &:first-child {
                    text-align: left;
                    padding-left: 30px / $ppr;
                }
                &:last-child {
                    text-align: right;
                    padding-right: 40px / $ppr;
                }
            }
            tr {
                &:nth-child(2n) {
                    background: #fafafa;
                }
                &:first-child {
                    border-radius: 20px / $ppr 20px / $ppr 0 0;
                }
                &:last-child {
                    border-radius: 0 0 20px / $ppr 20px / $ppr;
                }
            }
        }
        .icon_arrow_right {
            display: inline-block;
            width: 12px / $ppr;
            height: 22px / $ppr;
            background: url(../img/icon_arrow_right.png) no-repeat center;
            background-size: cover;
            margin-left: 10px / $ppr;
            margin-right: -30px / $ppr;
        }
    }
}
.c-999 {
    color: #999;
}
</style>
